import { Toast } from 'vant';
import NavBar from '@/components/Nav.vue';
import ShowCase from '@/components/ShowCase.vue';
import recommend from '@/pages/ProductDetail/components/recommend'

import functions from '@/functions.js';
import enums from '@/configs/enums.js';
import client from '@/configs/client.js';

export default {
    name: 'ProductDetailPage',
    components: {
        ShowCase,
        NavBar,
        recommend
    },
    data() {
        return {
            tokenInvalid: false, // token是否失效
            loading: false,
            supportShow: false,
            subscribe: false,
            organizationSubscribe: false,
            priority: 0,
            product: {tags: [], organization: {}, issuer: {}},
            types: enums.productType,
            states: enums.productState,
            dateFormat: functions.dateFormat,
            watermark: this.$route.query.token,
            show: true,
            timer: null,
            checkTimer: null,
            entityKey: null,
            successType: '',
            openEntity: {},
            client: client,
            showInformResult: false,
            blindboxSelected: null
        }
    },
    created() {
        if (this.$store.state.containerEntity) {
            this.successType = 'unpack';
            this.openEntity = this.$store.state.containerEntity;
            this.$store.state.containerEntity = null;
        }
        let params = {}
        if (this.$route.query.token) {
            params.token = this.$route.query.token
        } else if (this.$route.query.accessToken) {
            params.accessToken = this.$route.query.accessToken
        }
        this.$http.get('product/' + this.$route.params.id, {params: params}).then(result => {
            this.show = false;
            if (result.data.product.raffle) {
                for (let key in result.data.product.raffle.timeline) {
                    result.data.product.raffle[key + '_active'] = ! result.data.product.raffle.timeline[key] || Date.parse(result.data.product.raffle.timeline[key]) <= new Date().getTime();
                }
            }
            this.product = result.data.product;
            this.priority = result.data.priority ? result.data.priority : 0;
            this.subscribe = result.data.subscribe;
            this.organizationSubscribe = result.data.organizationSubscribe;
            // if (this.showInformResult && this.$store.state['showInformResult' + this.product.id]) {
            //     this.showInformResult = false;
            // } else {
            //     this.$store.state['showInformResult' + this.product.id] = true;
            // }
            // 设置实时状态
            this.setState(this.product);
            this.showInformResult = this.product.raffle && this.product.raffle.is_hint !== null && this.product.raffle.inform_active && ! this.product.priority_active && this.product.state == this.states.waiting && ! this.$store.state['showInformResult' + this.product.id];
            if (this.showInformResult) {
                this.$store.state['showInformResult' + this.product.id] = true;
            }
            // 存储时间差异，实现页面倒计时效果
            let now = Date.parse(new Date) / 1000;
            let releaseTime = Date.parse(new Date(this.product.release_time)) / 1000;
            let diff = releaseTime - now - this.priority;
            this.product.diff = {hour: Math.floor(diff / 3600), minute: Math.floor(diff % 3600 / 60), second: Math.floor(diff % 60)};
            // 存储开始抽签时间差异
            if (this.product.raffle) {
                let raffleTime = Date.parse(new Date(this.product.raffle.timeline.subscribe_start)) / 1000
                let raffleDiff = raffleTime - now;
                this.product.raffle.diff = {hour: Math.floor(raffleDiff / 3600), minute: Math.floor(raffleDiff % 3600 / 60), second: Math.floor(raffleDiff % 60)};
            }
            // 初始化分享
            this.initShare({ 
                title: this.product.share_title,
                description: this.product.share_description,
                image: this.product.share_image
            });
            this.timer = setInterval(() => {
                // 设置实时状态
                this.setState(this.product);
                // 页面倒计时
                if (this.product.state == this.states.waiting) {
                    this.product.diff.second--;
                    if (this.product.diff.second < 0) {
                        this.product.diff.minute--;
                        this.product.diff.second = 59;
                        if (this.product.diff.minute < 0) {
                            this.product.diff.hour--;
                            this.product.diff.minute = 59;
                        }
                    }
                } else if (this.product.state == this.states.offline) {
                    clearInterval(this.timer);
                }
                // 抽签倒计时
                if (this.product.raffle) {
                    this.product.raffle.subscribe_start_active = Date.parse(new Date) >= Date.parse(new Date(this.product.raffle.timeline.subscribe_start));
                    if (! this.product.raffle.subscribe_start_active) {
                        this.product.raffle.diff.second--;
                        if (this.product.raffle.diff.second < 0) {
                            this.product.raffle.diff.minute--;
                            this.product.raffle.diff.second = 59;
                            if (this.product.raffle.diff.minute < 0) {
                                this.product.raffle.diff.hour--;
                                this.product.raffle.diff.minute = 59;
                            }
                        }
                    }
                }
            }, 1000);
        }).catch(err => {
            if (err.code === 1005) {
                this.show = false
                this.tokenInvalid = true
            }
        })
    },
    unmounted() {
        this.initShare();
        clearInterval(this.timer);
        clearInterval(this.checkTimer);
    },
    methods: {
        // 返回首页
        goHome () {
            this.$router.replace('/');
        },
        changeBlindbox(value) {
            this.blindboxSelected = value;
        },
        prefixZero(number) {
            return (number < 10 ? '0' : '') + number;
        },
        purchase() {
            if (this.product.type == this.types.container && this.blindboxSelected === null) {
                Toast('请选择盲盒');
                return false;
            }
            if (!client.xinhua) {
                if (Number(this.product.price) > 0) {
                    console.log('客户端内购买')
                    let url = window.location.href
                    url = url.replace('close=1', 'close=0')
                    let query = {
                        xhw_page_style: '10000000'
                    }
                    window.openAppManage.open('', '', '', '', url, query)
                    return
                }
            }
            if (! this.loading) {
                this.loading = true;
                this.$http.post('product/' + this.product.id + '/purchase').then(result => {
                    if (result.data.order_id) {
                        this.payment(result.data.order_id);
                    } else {
                        this.entityKey = result.data.entity_id;
                        this.successType = this.product.type == this.types.container ? 'unpack' : 'common';
                        if (this.successType == 'unpack') {
                            this.openEntity = result.data.entity;
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        payment(orderKey) {
            // 判断在端内还是端外
            if (client.xinhua) {
                this.$http.get('order/' + orderKey + '/queryOrder').then(result => {
                    let data = {
                        uuid: result.data.productNumber,
                        priceId: result.data.priceId,
                        type: 12,
                        orderId: result.data.orderNumber
                    }
                    if (client.ios) {
                        window.webkit.messageHandlers.goPayPage.postMessage(data);
                    } else {
                        /* eslint-disable */
                        xinhuanet.goPayPage(JSON.stringify(data));
                        /* eslint-enable */
                    }
                });
                // 检测订单结果
                clearInterval(this.checkTimer);
                this.checkTimer = setInterval(() => {
                    this.$http.get('order/' + orderKey + '/check').then(result => {
                        if (result.data.state != enums.orderState.waiting) {
                            if (result.data.state == enums.orderState.complete) {
                                this.entityKey = result.data.entity.id;
                                this.successType = this.product.type == this.types.container ? 'unpack' : 'common';
                                if (this.successType == 'unpack') {
                                    this.openEntity = result.data.entity;
                                }
                            }
                            clearInterval(this.checkTimer);
                        }
                    })
                }, 2000);
            } else {
                //this.$http.get('order/' + orderKey + '/cashier', {params: {url: location.href}}).then(result => {
                //    location.href = result.data.url;
                //});
            }
        },
        toggleProductSubscribe() {
            if (! this.subscribe && ! this.loading) {
                this.loading = true;
                this.$http.put('product/' + this.product.id + '/subscribe').then(result => {
                    if (this.subscribe) {
                        this.subscribe = false;
                    } else {
                        this.subscribe = true;
                        this.product.raffle.subscribe_type = this.product.raffle && ! this.product.raffle.subscribe_end_active;
                        if (this.product.raffle && result.data.is_hint !== null) {
                            this.showInformResult = true;
                            this.product.raffle.is_hint = result.data.is_hint;
                        }
                    }
                    Toast('预约成功');
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        toggleOrganizationSubscribe() {
            if (! this.loading) {
                this.loading = true;
                this.$http.put('organization/' + this.product.organization_id + '/subscribe').then(() => {
                    if (this.organizationSubscribe) {
                        this.organizationSubscribe = false;
                    } else {
                        this.organizationSubscribe = true;
                    }
                    Toast('操作成功');
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        setState(product) {
            let now = Date.parse(new Date);
            if (product.state == this.states.waiting && now + this.priority * 1000 >= Date.parse(new Date(product.release_time))) {
                product.state = this.states.normal;
            } else if (product.state == this.states.normal) {
                let offlineTime = Date.parse(new Date(product.offline_time));
                if (offlineTime && now > offlineTime) {
                    product.state = this.states.offline;
                }
            }
        }
    }
}